export default "__VITE_ASSET__Ce1n4uH0__"